webpackJsonp([3],{

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(325),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(73);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(72);

var _mutation = __webpack_require__(10);

var types = _interopRequireWildcard(_mutation);

var _com = __webpack_require__(9);

var _headernav = __webpack_require__(115);

var _headernav2 = _interopRequireDefault(_headernav);

__webpack_require__(309);

var _elementUi = __webpack_require__(45);

var _config = __webpack_require__(28);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            isPlayed: true,
            bgAudio: false,
            scenario: null,
            rating: null,
            scene: null,
            rate: null,
            interlude: null,
            page: 1,
            clientid: 1,
            limit: 10,
            author: null,
            newPageList: [],
            musicList: [],
            currentClick: null
        };
    },

    components: {
        headernav: _headernav2.default
    },
    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
        jokedata: 'jokeData',
        joketotal: 'jokeTotalItem',
        interludeItems: 'interlude',
        getAccesstoken: 'getAccesstoken',
        getAppid: 'getAppid',
        interludeUrl: 'interludeUrl',
        currentIndex: 'currentIndex',
        autoplay: 'autoplay'
    }), {
        jokeRate: function jokeRate() {
            return _config.jokeRating;
        }
    }),
    created: function created() {
        this.scenario = _config.jokeScenario;
        this.rating = _config.jokeRating;
        var curpage = this.$route.query.page || 1;
        this.page = parseInt(curpage);
        this.reqJokeListData();
    },

    watch: {
        '$route': function $route(to, from) {
            console.debug("watch>route start to:%o, from:%o", to, from);
            console.debug("watch>route page:%o", this.$route.query.page);
            var curpage = this.$route.query.page || 1;
            this.page = parseInt(curpage);
            this.scene = this.$route.query.scenario;
            this.rate = this.$route.query.rating;
            this.reqJokeListData();
        }
    },
    mounted: function mounted() {
        this.reqInterludeList();
    },
    updated: function updated() {
        this.autoplayjoke();
        this.musicList = this.$refs.audio;
    },

    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
        getJokeList: 'getJokeList',
        updateLoadingStatus: 'updateLoadingStatus',
        getInterludeList: 'getInterludeList',
        setInterludeUrl: 'setInterludeUrl',
        setCurrentIndex: 'setCurrentIndex',
        setAutoPlay: 'setAutoPlay',
        outLogin: 'outLogin'
    }), {
        playMusic: function playMusic(index) {
            if (index !== this.currentIndex) {
                this.isPlayed = true;
                this.setAutoPlay(false);
                this.currentClick = index;
                this.setCurrentIndex(index);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.musicList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var v = _step.value;

                        if (v.currentTime != 0) {
                            v.pause();
                            v.currentTime = 0;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.isPlayed = false;
                this.musicList[index].play();
            } else {
                this.isPlayed = !this.isPlayed;
                if (this.isPlayed) {
                    this.musicList[index].pause();
                } else {
                    this.musicList[index].play();
                }
            }
        },
        jokeEnd: function jokeEnd(_index) {
            var _that_ = this;
            this.setAutoPlay(true);
            this.isPlayed = true;
            var music = this.$refs.audio;
            var index = this.currentIndex;
            var pageItems = Math.ceil(this.joketotal / 10) + 1;
            if (this.interludeUrl) {
                this.$nextTick(function () {
                    return _that_.$refs.bgAudio.play();
                });
            } else {
                if (music) {
                    index++;
                    this.setCurrentIndex(index);

                    if (index < music.length) {
                        music[index].play();
                        this.goToAnchor('floor' + index);
                    } else {
                        this.page++;

                        if (this.page < pageItems) {
                            this.handlePageChange(this.page);
                        } else {
                            console.log('全部播放完毕');
                            this.setAutoPlay(false);
                            return;
                        }
                    }
                }
            }
        },
        bgEnd: function bgEnd() {
            var music = this.$refs.audio;
            var index = this.currentIndex;
            var pageItems = Math.ceil(this.joketotal / 10) + 1;
            index++;
            this.setCurrentIndex(index);
            if (index < music.length) {
                music[index].play();
                this.goToAnchor('floor' + index);
            } else {
                this.page++;

                if (this.page < pageItems) {
                    this.handlePageChange(this.page);
                } else {
                    console.log('全部播放完毕');
                    this.setAutoPlay(false);
                    return;
                }
            }
        },
        autoplayjoke: function autoplayjoke() {
            var items = this.$refs.audio;

            var isAnyItemPlayed = '';
            if (items[0]) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = (0, _getIterator3.default)(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var v = _step2.value;

                        if (v.currentTime != 0) {
                            isAnyItemPlayed = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (items && this.autoplay && !isAnyItemPlayed) {
                    items[0].play();
                    this.setCurrentIndex(0);
                }
            }
        },
        goToAnchor: function goToAnchor(index) {
            var anchor = document.getElementById(index);
            var total = anchor.offsetTop;
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total;
            window.pageYOffset = total;
        },

        reqJokeListData: function reqJokeListData() {
            var _that_ = this;
            var param = {
                appid: _that_.getAppid,
                accesstoken: _that_.getAccesstoken,
                scenario: _that_.scene,
                rating: _that_.rate,
                author: _that_.author,
                page: _that_.page,
                limit: _that_.limit
            };

            _that_.updateLoadingStatus(true);
            _that_.getJokeList(param).then(function (resp) {
                _that_.updateLoadingStatus(false);
                console.debug("reqNewsListData> getJokeList> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    _that_.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                    setTimeout(function () {
                        _that_.outLogin();
                        _that_.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: 'joke' } });
                    }, 3000);
                }
            });
        },
        reqInterludeList: function reqInterludeList() {
            var _that_ = this;
            var param = {
                appid: _that_.getAppid,
                accesstoken: _that_.getAccesstoken,
                clientid: _that_.clientid,
                scenario: _that_.scene
            };
            _that_.getInterludeList(param).then(function (resp) {
                console.debug("getInterludeList> resp:%o", resp);
                if (resp && resp.code !== 0) {
                    _that_.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                    setTimeout(function () {
                        _that_.outLogin();
                        _that_.$router.push({ path: (0, _com.routeMap)('/login'), query: { type: 'joke' } });
                    }, 3000);
                }
            });
        },
        handleScenarioChange: function handleScenarioChange() {
            this.$router.push({ path: (0, _com.routeMap)('/joke/list'), query: { page: this.page, scenario: this.scene, rating: this.rate } });
        },
        handleRateChange: function handleRateChange() {
            this.$router.push({ path: (0, _com.routeMap)('/joke/list'), query: { page: this.page, scenario: this.scene, rating: this.rate } });
        },
        handleInterludeChange: function handleInterludeChange(val) {
            this.setInterludeUrl(val);
        },
        handlePageChange: function handlePageChange(val) {
            console.debug("handlePageChange> val:%o", val);
            if (this.page !== val) {
                this.page = val;
            }
            this.$router.push({ path: (0, _com.routeMap)('/joke/list'), query: { page: this.page, scenario: this.scene, rating: this.rate } });
        }
    })
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(273)();
// imports


// module
exports.push([module.i, "#joke{width:100%;height:100%}#joke .toolbar-nav a{color:#b50739;font-size:40px}#joke .content .search-area{height:76px;width:auto}#joke #joke-selections{display:flex;justify-content:space-between;padding-top:20px;padding-bottom:20px;position:fixed;top:4.5rem;z-index:50;background:#f3f3f3}#joke #joke-selections>.el-input{width:30%}#joke #joke-list .joke-items .joke-item{padding:20px;color:#99a9bf;margin-bottom:20px;border:1px solid #ddd;background:#fff;position:relative}#joke #joke-list .joke-items .joke-item .joke-item-header{display:flex;justify-content:space-between}#joke #joke-list .joke-items .joke-item .joke-item-header .scenario{color:#58b7ff;font-weight:700;font-size:1.2rem}#joke #joke-list .joke-items .joke-item .joke-item-header .rating{color:#d22953;font-weight:700;font-size:1.2rem}#joke #joke-list .joke-items .joke-item .title{margin-top:10px;color:#000;font-size:1.6rem;font-weight:700}#joke #joke-list .joke-items .joke-item .joke-item-content .stuff-info{font-size:.8rem;margin-top:10px;margin-bottom:10px}#joke #joke-list .joke-items .joke-item .joke-item-content .text{text-overflow:ellipsis;margin-bottom:10px}#joke #joke-list .joke-items .joke-item .joke-item-content .tags{font-size:.8rem;float:right}#joke #joke-list .joke-items .joke-item .joke-item-content:after{display:block;content:\"\";clear:both}#joke #joke-list .joke-items .joke-item .sound{position:absolute;width:100%;height:100%;top:0;left:0;color:#000;font-size:40px}#joke #joke-list .joke-items .joke-item .sound>div.joke-play-button{position:absolute;top:50%;left:50%;transform:translate(-38%,-50%);-ms-transform:translate(-38%,-50%);-moz-transform:translate(-38%,-50%);-webkit-transform:translate(-38%,-50%);-o-transform:translate(-38%,-50%)}#joke #joke-list .joke-items .joke-item .sound>div.joke-play-button img{width:80%;opacity:0}#joke #joke-list .joke-items .joke-item .active{background:rgba(0,0,0,.1)}#joke #joke-list .joke-items .joke-item .active>div.joke-play-button img{opacity:.5}#joke #joke-list .joke-pagination{background:#fff;border:1px solid #ddd;padding:10px;margin-bottom:20px}#joke #joke-list .joke-pagination .el-pagination{margin-top:0}", "", {"version":3,"sources":["D:/project/atlanta-git-clone/src/static/style/joke/D:\\project\\atlanta-git-clone/src\\static\\style\\joke\\index.scss"],"names":[],"mappings":"AAAA,MACI,WAAW,AACX,WAAY,CAqIf,AAvID,qBAKY,cAAc,AACd,cAAc,CACjB,AAPT,4BAWY,YAAW,AACX,UAAW,CACd,AAbT,uBAgBQ,aAAY,AACZ,8BAA8B,AAG9B,iBAAgB,AAChB,oBAAmB,AACnB,eAAc,AACd,WAAU,AACV,WAAU,AACV,kBAAmB,CAItB,AA7BL,iCA2BY,SAAS,CACZ,AA5BT,wCAkCgB,aAAa,AACb,cAAc,AACd,mBAAkB,AAClB,sBAAqB,AACrB,gBAAgB,AAChB,iBAAiB,CAoFpB,AA3Hb,0DAyCoB,aAAa,AACb,6BAA6B,CAYhC,AAtDjB,oEA4CwB,cAAc,AACd,gBAAgB,AAChB,gBAAgB,CACnB,AA/CrB,kEAiDwB,cAAc,AACd,gBAAgB,AAChB,gBAAgB,CACnB,AApDrB,+CAwDoB,gBAAe,AACf,WAAW,AACX,iBAAgB,AAChB,eAAgB,CACnB,AA5DjB,uEA+DwB,gBAAe,AACf,gBAAe,AACf,kBAAkB,CACrB,AAlErB,iEAoEwB,uBAAuB,AACvB,kBAAkB,CACrB,AAtErB,iEAwEwB,gBAAe,AACf,WAAW,CACd,AA1ErB,iEA4EwB,cAAc,AACd,WAAU,AACV,UAAU,CACb,AA/ErB,+CAkFoB,kBAAiB,AACjB,WAAU,AACV,YAAW,AACX,MAAK,AACL,OAAM,AACN,WAAW,AACX,cAAc,CAyBjB,AAjHjB,oEA0FwB,kBAAiB,AACjB,QAAO,AACP,SAAQ,AACR,+BAA8B,AAC9B,mCAAkC,AAClC,oCAAmC,AACnC,uCAAsC,AACtC,iCAAiC,CAKpC,AAtGrB,wEAmG4B,UAAS,AACT,SAAS,CACZ,AArGzB,gDAmHoB,yBAA0B,CAM7B,AAzHjB,yEAsHgC,UAAW,CACd,AAvH7B,kCA8HY,gBAAgB,AAChB,sBAAqB,AACrB,aAAY,AACZ,kBAAkB,CAIrB,AArIT,iDAmIgB,YAAY,CACf","file":"index.scss","sourcesContent":["#joke {\r\n    width: 100%;\r\n    height: 100%;\r\n    .toolbar-nav{\r\n        a{\r\n            color: #B50739;\r\n            font-size:40px;\r\n        }\r\n    }\r\n    .content{\r\n        .search-area{\r\n            height:76px;\r\n            width: auto;\r\n        }\r\n    }\r\n    #joke-selections{\r\n        display:flex;\r\n        justify-content: space-between;\r\n        // margin-top:20px;\r\n        // margin-bottom:20px;\r\n        padding-top:20px;\r\n        padding-bottom:20px;\r\n        position:fixed;\r\n        top:4.5rem;\r\n        z-index:50;\r\n        background: #f3f3f3;\r\n        &>.el-input{\r\n            width:30%;\r\n        }\r\n    }\r\n    #joke-list{\r\n        .joke-items{\r\n            \r\n            .joke-item{\r\n                padding: 20px;\r\n                color: #99a9bf;\r\n                margin-bottom:20px;\r\n                border:1px solid #ddd;\r\n                background: #fff;\r\n                position:relative;\r\n                .joke-item-header{\r\n                    display: flex;\r\n                    justify-content:space-between; \r\n                    .scenario{\r\n                        color: #58b7ff;\r\n                        font-weight: 700;\r\n                        font-size:1.2rem;\r\n                    }\r\n                    .rating{\r\n                        color: #d22953;\r\n                        font-weight: 700;\r\n                        font-size:1.2rem;\r\n                    }\r\n                    \r\n                }\r\n                .title{\r\n                    margin-top:10px;\r\n                    color:black;\r\n                    font-size:1.6rem;\r\n                    font-weight: 700;\r\n                }\r\n                .joke-item-content{\r\n                    .stuff-info{\r\n                        font-size:.8rem;\r\n                        margin-top:10px;\r\n                        margin-bottom:10px;\r\n                    }\r\n                    .text{\r\n                        text-overflow: ellipsis;\r\n                        margin-bottom:10px;\r\n                    }\r\n                    .tags{\r\n                        font-size:.8rem;\r\n                        float:right;\r\n                    }\r\n                    &:after{\r\n                        display: block;\r\n                        content:'';\r\n                        clear:both;\r\n                    }\r\n                }\r\n                .sound{\r\n                    position:absolute;\r\n                    width:100%;\r\n                    height:100%;\r\n                    top:0;\r\n                    left:0;\r\n                    color:black;\r\n                    font-size:40px;\r\n                    >div.joke-play-button{\r\n                        position:absolute;\r\n                        top:50%;\r\n                        left:50%;\r\n                        transform:translate(-38%,-50%);\r\n                        -ms-transform:translate(-38%,-50%); \t/* IE 9 */\r\n                        -moz-transform:translate(-38%,-50%); \t/* Firefox */\r\n                        -webkit-transform:translate(-38%,-50%); /* Safari 和 Chrome */\r\n                        -o-transform:translate(-38%,-50%); \r\n                        img{\r\n                            width:80%;\r\n                            opacity:0;\r\n                        }\r\n                    }\r\n                    // -webkit-transform: translate(-50% -50%);\r\n                    // transform: translate(-50% -50%);\r\n                    // &:hover{\r\n                    //     background: rgba(0,0,0,.1);\r\n                    //     >div.joke-play-button{\r\n                    //         img{\r\n                    //             opacity:0.5;\r\n                    //         }\r\n                    //     }\r\n                    // }\r\n                }\r\n                .active{\r\n                    background: rgba(0,0,0,.1);\r\n                        >div.joke-play-button{\r\n                            img{\r\n                                opacity:0.5;\r\n                            }\r\n                        }\r\n                }\r\n\r\n            }\r\n        }\r\n        .joke-pagination{\r\n            background: #fff;\r\n            border:1px solid #ddd;\r\n            padding:10px;\r\n            margin-bottom:20px;\r\n            .el-pagination{\r\n                margin-top:0;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(274)("1b088c20", content, true);

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pause.837c300.png";

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/play.660a9c9.png";

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "joke"
    }
  }, [_c('headernav', {
    attrs: {
      "type": "joke"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "search-area",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 22,
      "sm": 24,
      "lg": 14,
      "xs": 24,
      "id": "joke-selections"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "选择场景:如动物、家庭。。。",
      "clearable": ""
    },
    model: {
      value: (_vm.scene),
      callback: function($$v) {
        _vm.scene = $$v
      },
      expression: "scene"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.handleScenarioChange
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择分级"
    },
    on: {
      "change": _vm.handleRateChange
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  }, _vm._l((_vm.rating), function(key, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": key,
        "value": value
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "选择过场音效"
    },
    on: {
      "change": _vm.handleInterludeChange
    },
    model: {
      value: (_vm.interlude),
      callback: function($$v) {
        _vm.interlude = $$v
      },
      expression: "interlude"
    }
  }, _vm._l((_vm.interludeItems), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.url
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "md": 22,
      "sm": 24,
      "lg": 14,
      "xs": 24,
      "id": "joke-list"
    }
  }, [_c('div', {
    staticClass: "joke-items"
  }, _vm._l((_vm.jokedata), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "joke-item",
      attrs: {
        "id": 'floor' + index
      }
    }, [_c('div', {
      staticClass: "joke-item-header"
    }, [_c('p', {
      staticClass: "scenario"
    }, [_vm._v(_vm._s(item.scenario))]), _vm._v(" "), _c('p', {
      staticClass: "rating"
    }, [_vm._v(_vm._s(item.rating) + "、" + _vm._s(_vm.jokeRate[item.rating]))])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "joke-item-content"
    }, [_c('div', {
      staticClass: "stuff-info"
    }, [_c('span', [_vm._v("作者：" + _vm._s(item.author))]), _vm._v(" "), _c('span', [_vm._v("审核：" + _vm._s(item.auditor))])]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_vm._v("\r\n                                " + _vm._s(item.tags) + "\r\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "sound",
      class: {
        active: _vm.currentIndex === index
      }
    }, [_c('div', {
      staticClass: "joke-play-button",
      on: {
        "click": function($event) {
          _vm.playMusic(index)
        }
      }
    }, [(_vm.isPlayed && _vm.currentClick === index ? true : false) ? _c('img', {
      attrs: {
        "src": __webpack_require__(318)
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(317)
      }
    })]), _vm._v(" "), _c('audio', {
      ref: "audio",
      refInFor: true,
      attrs: {
        "src": item.url
      },
      on: {
        "ended": function($event) {
          _vm.jokeEnd(index)
        }
      }
    }, [_vm._v("\r\n                                抱歉！您的浏览器暂不支持播放此音频，请更换或升级浏览器\r\n                            ")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "joke-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.joketotal
    },
    on: {
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bgAudio),
      expression: "bgAudio"
    }],
    staticClass: "bg-audio"
  }, [_c('audio', {
    ref: "bgAudio",
    attrs: {
      "src": _vm.interludeUrl
    },
    on: {
      "ended": function($event) {
        _vm.bgEnd()
      }
    }
  }, [_vm._v("\r\n                抱歉！您的浏览器暂不支持播放此音频，请更换或升级浏览器\r\n            ")])])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.9aa5930c9f5a615006ba.js